import { Skeleton } from '../../../feedback/skeleton';

export const CellSkeleton = () => {
  return <Skeleton className="DS-Table-CellSkeleton" />;
};
